import React, { Component, Fragment } from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import * as actions from "../../store/actions/index.js";
import logo from "../../assets/images/amps-logo.png";
import Input from "../../components/UI/Input/Input";
import Button from "../../components/UI/Button/Button";
import RoutePath from "../RoutePath/RoutePath";
import Spinner from "../../components/UI/Spinner/Spinner";
import InfoWindow from "../../components/UI/Alerts/InfoWindow/InfoWindow";
import Modal from "../../components/UI/Modal/Modal";
import LoginAlert from "../../components/UI/Alerts/LoginAlert/LoginAlert";

interface IStatefromProps {
  token: string;
  loading: boolean;
  error: boolean;
  errorMessage: string;
}
interface IDispatchFromProps {
  onFetchAccessToken: (email: string, password: string) => void;
}

type Props = IStatefromProps & IDispatchFromProps & RouteComponentProps;
class Login extends Component<Props> {
  state = {
    email: "",
    password: "",
    token: "",
    showPassword: false,
    forgotPassword: false,
    loginClicked: false,
    linkClicked: false,
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  componentDidMount() {
    // this.props.location.search.
    // console.log(
    //   "params",
    //   this.props.location.search.split("?")[1].split("=")[0]
    // );
    if (
      this.props.location.search.split("?")[1] &&
      this.props.location.search.split("?")[1].split("=")[0].toLowerCase() ===
        "id_token"
    ) {
      // if (
      //   localStorage.getItem("linkClicked")?.toLowerCase() !==
      //     "forgot password" &&
      //   localStorage.getItem("linkClicked")?.toLowerCase() !== "register"
      // ) {
      //   this.setState({ linkClicked: false });
      //   sessionStorage.setItem(
      //     "token",
      //     this.props.location.search.split("?")[1].split("=")[1]
      //   );
      //   this.props.history.replace("/home");
      // } else {
        this.setState({ linkClicked: true });
      // }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("prevToken",prevProps.token)
    console.log("currentToken",this.props.token)
    if (this.props.token !== prevProps.token && this.props.token) {
      console.log("token", this.props.token);
      sessionStorage.setItem(`token`, this.props.token);
      this.setState({ token: this.props.token });
    }
    if (
      prevState.loginClicked !== this.state.loginClicked &&
      this.state.loginClicked
    ) {
      if (this.state.email && this.state.password) {
        this.props.onFetchAccessToken(this.state.email, this.state.password);
      }
    }
    if (
      prevState.email !== this.state.email ||
      prevState.password !== this.state.password
    ) {
      this.setState({ loginClicked: false });
    }
  }
  onChangeShowPassword = (event) => {
    console.log(event.target.checked, event.target.name);
    if (event.target.checked) {
      this.setState({ showPassword: true });
    } else if (!event.target.checked) {
      this.setState({ showPassword: false });
    }
  };
  openLinkClicked = (e) => {
    console.log("link clicked", e.target.innerText);
    localStorage.setItem("linkClicked", e.target.innerText);
  };

  closeLinkClicked = () => {
    this.setState({ linkClicked: false });
    localStorage.removeItem("linkClicked");
  };
  render() {
    const clickHandler = () => {
      this.setState({ loginClicked: true });
    };

    const elementLabelStyle = {
      display: "none",
    };
    const elementInputStyle = {
      fontSize: "1em",
      border: "0",
    };
    const alertModal = {
      width: "360px",
      left: "calc(50% - 180px)",
      top: "33%",
    };
    const btnStyle = {
      borderRadius: "5px",
      width: "100%",
      marginTop: "20px",
    };

    let spinner: any;
    if (this.props.loading) {
      spinner = <Spinner />;
    }

    let linkClicked: any;
    if (this.state.linkClicked) {
      linkClicked = (
        <Modal
          show={true}
          childComp={
            <LoginAlert
              modalClosed={this.closeLinkClicked}
              infoText={
                localStorage.getItem("linkClicked") === "Forgot Password"
                  ? "Reset Password Successfully. Please Login to Continue"
                  : `Registration Completed Successfully. Please Login to Continue`
              }
            />
          }
          style={alertModal}
        />
      );
    }

    let loggedIn: any;
    if (this.state.token) {
      loggedIn = <RoutePath />;
    } else {
      loggedIn = (
        <div className="custom-wrapper">
          <div className="custom-box">
            <div className="c-logo">
              <Image src={logo} alt="logo" />
            </div>
            <h2>Sign in with your existing account</h2>
            {this.props.error && (
              <div className="login-error login-error-alert">
                {this.props.errorMessage}
              </div>
            )}
            <div className="custom-form">
              {this.state.loginClicked && this.state.email === "" && (
                <div className="login-error">Please enter your email</div>
              )}
              <Input
                label=""
                supportLabel=""
                type="email"
                placeholder="Email Address"
                elementLabelStyle={elementLabelStyle}
                elementInputStyle={elementInputStyle}
                name="email"
                errorText=""
                value={this.state.email}
                onChange={(e) => this.handleChange(e)}
              />
              {this.state.loginClicked && this.state.password === "" && (
                <div className="login-error">Please enter your password</div>
              )}
              <Input
                label=""
                type={this.state.showPassword ? "text" : "password"}
                supportLabel=""
                placeholder="Password"
                elementLabelStyle={elementLabelStyle}
                elementInputStyle={elementInputStyle}
                name="password"
                errorText=""
                value={this.state.password}
                onChange={(e) => this.handleChange(e)}
              />
              <div className="show-pwd">
                <label>
                  <input
                    type="checkbox"
                    id="customSwitches"
                    onChange={this.onChangeShowPassword}
                  />{" "}
                  Show password
                </label>
              </div>
              <Button
                label="Login"
                clicked={clickHandler}
                style={btnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
              <div
                className="row mt-3"
                onClick={(e) => this.openLinkClicked(e)}
              >
                <div className="col-6">
                  {/* <a className="c-link" onClick={this.onForgotPassword}> */}
                  <a
                    className="c-link"
                    href={`${process.env.REACT_APP_FORGOT_PASSWORD_URL}${process.env.REACT_APP_REDIRECT_URL}${process.env.REACT_APP_FORGOT_PASSWORD_URL_PARAMS}`}
                  >
                    Forgot Password
                  </a>
                </div>
                <div className="col-6 text-right">
                  <a
                    className="c-link"
                    href={`${process.env.REACT_APP_REGISTER_URL}${process.env.REACT_APP_REDIRECT_URL}${process.env.REACT_APP_REGISTER_URL_PARAMS}`}
                  >
                    Register
                  </a>
                </div>
              </div>
              <div className="c-terms">
                <a
                  className="t-link"
                  href="https://ampsqa.blob.core.windows.net/ampsqa/terms-web.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of use
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        {spinner}
        {loggedIn}
        {linkClicked}
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  token: state.fetchAccessToken.token,
  loading: state.fetchAccessToken.loading,
  error: state.fetchAccessToken.error,
  errorMessage: state.fetchAccessToken.errorMessage,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchAccessToken: (email, password) =>
    dispatch(actions.fetchAccessToken(email, password)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
